/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PostRoleManagementUsersUserIdRoleParams,
  RegisterResponseDTO,
  RoleMatrixDto,
  RolePermissionDto,
  TenantAppRoleDto,
  TenantUserDto,
  UserDto,
  UserRoleAssignmentDto,
} from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get Matrix
 */
export const getRoleManagementMatrix = (signal?: AbortSignal) => {
  return customInstance<RoleMatrixDto>({
    url: `/role-management/matrix`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementMatrixInfiniteQueryKey = () => {
  return ["infinite", `/role-management/matrix`] as const;
};

export const getGetRoleManagementMatrixQueryKey = () => {
  return [`/role-management/matrix`] as const;
};

export const getGetRoleManagementMatrixInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementMatrix>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementMatrix>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementMatrixInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementMatrix>>
  > = ({ signal }) => getRoleManagementMatrix(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementMatrix>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementMatrixInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementMatrix>>
>;
export type GetRoleManagementMatrixInfiniteQueryError = void;

export function useGetRoleManagementMatrixInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementMatrix>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementMatrix>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementMatrixInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementMatrix>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementMatrix>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementMatrixInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementMatrix>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Matrix
 */

export function useGetRoleManagementMatrixInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementMatrix>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementMatrixInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementMatrixQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementMatrix>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementMatrix>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementMatrixQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementMatrix>>
  > = ({ signal }) => getRoleManagementMatrix(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementMatrix>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementMatrixQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementMatrix>>
>;
export type GetRoleManagementMatrixQueryError = void;

export function useGetRoleManagementMatrix<
  TData = Awaited<ReturnType<typeof getRoleManagementMatrix>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementMatrix>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementMatrix<
  TData = Awaited<ReturnType<typeof getRoleManagementMatrix>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementMatrix>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementMatrix>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementMatrix<
  TData = Awaited<ReturnType<typeof getRoleManagementMatrix>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Matrix
 */

export function useGetRoleManagementMatrix<
  TData = Awaited<ReturnType<typeof getRoleManagementMatrix>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementMatrix>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementMatrixQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Available Permission Keys
 */
export const getRoleManagementPermissions = (signal?: AbortSignal) => {
  return customInstance<RolePermissionDto[]>({
    url: `/role-management/permissions`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementPermissionsInfiniteQueryKey = () => {
  return ["infinite", `/role-management/permissions`] as const;
};

export const getGetRoleManagementPermissionsQueryKey = () => {
  return [`/role-management/permissions`] as const;
};

export const getGetRoleManagementPermissionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementPermissions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementPermissionsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  > = ({ signal }) => getRoleManagementPermissions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementPermissionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementPermissions>>
>;
export type GetRoleManagementPermissionsInfiniteQueryError = void;

export function useGetRoleManagementPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Available Permission Keys
 */

export function useGetRoleManagementPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRoleManagementPermissionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementPermissions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementPermissions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementPermissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>
  > = ({ signal }) => getRoleManagementPermissions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementPermissions>>
>;
export type GetRoleManagementPermissionsQueryError = void;

export function useGetRoleManagementPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementPermissions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementPermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementPermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Available Permission Keys
 */

export function useGetRoleManagementPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementPermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementPermissionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Roles
 */
export const getRoleManagementRoles = (signal?: AbortSignal) => {
  return customInstance<TenantAppRoleDto[]>({
    url: `/role-management/roles`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementRolesInfiniteQueryKey = () => {
  return ["infinite", `/role-management/roles`] as const;
};

export const getGetRoleManagementRolesQueryKey = () => {
  return [`/role-management/roles`] as const;
};

export const getGetRoleManagementRolesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRoles>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementRoles>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementRolesInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRoles>>
  > = ({ signal }) => getRoleManagementRoles(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementRoles>>
>;
export type GetRoleManagementRolesInfiniteQueryError = void;

export function useGetRoleManagementRolesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRoles>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRoles>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRoles>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Roles
 */

export function useGetRoleManagementRolesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRoles>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementRolesInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementRoles>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementRoles>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementRolesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRoles>>
  > = ({ signal }) => getRoleManagementRoles(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementRoles>>
>;
export type GetRoleManagementRolesQueryError = void;

export function useGetRoleManagementRoles<
  TData = Awaited<ReturnType<typeof getRoleManagementRoles>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRoles<
  TData = Awaited<ReturnType<typeof getRoleManagementRoles>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRoles>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRoles<
  TData = Awaited<ReturnType<typeof getRoleManagementRoles>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Roles
 */

export function useGetRoleManagementRoles<
  TData = Awaited<ReturnType<typeof getRoleManagementRoles>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRoles>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementRolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Role
 */
export const postRoleManagementRoles = (
  tenantAppRoleDto: TenantAppRoleDto,
  signal?: AbortSignal,
) => {
  return customInstance<TenantAppRoleDto>({
    url: `/role-management/roles`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: tenantAppRoleDto,
    signal,
  });
};

export const getPostRoleManagementRolesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRoleManagementRoles>>,
    TError,
    { data: TenantAppRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRoleManagementRoles>>,
  TError,
  { data: TenantAppRoleDto },
  TContext
> => {
  const mutationKey = ["postRoleManagementRoles"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRoleManagementRoles>>,
    { data: TenantAppRoleDto }
  > = (props) => {
    const { data } = props ?? {};

    return postRoleManagementRoles(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRoleManagementRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRoleManagementRoles>>
>;
export type PostRoleManagementRolesMutationBody = TenantAppRoleDto;
export type PostRoleManagementRolesMutationError = void;

/**
 * @summary Create Role
 */
export const usePostRoleManagementRoles = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRoleManagementRoles>>,
      TError,
      { data: TenantAppRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRoleManagementRoles>>,
  TError,
  { data: TenantAppRoleDto },
  TContext
> => {
  const mutationOptions = getPostRoleManagementRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Role
 */
export const putRoleManagementRolesId = (
  id: number,
  tenantAppRoleDto: TenantAppRoleDto,
) => {
  return customInstance<TenantAppRoleDto>({
    url: `/role-management/roles/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: tenantAppRoleDto,
  });
};

export const getPutRoleManagementRolesIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRoleManagementRolesId>>,
    TError,
    { id: number; data: TenantAppRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRoleManagementRolesId>>,
  TError,
  { id: number; data: TenantAppRoleDto },
  TContext
> => {
  const mutationKey = ["putRoleManagementRolesId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRoleManagementRolesId>>,
    { id: number; data: TenantAppRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putRoleManagementRolesId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutRoleManagementRolesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRoleManagementRolesId>>
>;
export type PutRoleManagementRolesIdMutationBody = TenantAppRoleDto;
export type PutRoleManagementRolesIdMutationError = void;

/**
 * @summary Update Role
 */
export const usePutRoleManagementRolesId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRoleManagementRolesId>>,
      TError,
      { id: number; data: TenantAppRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRoleManagementRolesId>>,
  TError,
  { id: number; data: TenantAppRoleDto },
  TContext
> => {
  const mutationOptions = getPutRoleManagementRolesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Role By Id
 */
export const getRoleManagementRolesId = (id: number, signal?: AbortSignal) => {
  return customInstance<TenantAppRoleDto>({
    url: `/role-management/roles/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementRolesIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/role-management/roles/${id}`] as const;
};

export const getGetRoleManagementRolesIdQueryKey = (id?: number) => {
  return [`/role-management/roles/${id}`] as const;
};

export const getGetRoleManagementRolesIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRolesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementRolesIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRolesId>>
  > = ({ signal }) => getRoleManagementRolesId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRolesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementRolesId>>
>;
export type GetRoleManagementRolesIdInfiniteQueryError = void;

export function useGetRoleManagementRolesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRolesId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesId>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRolesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesId>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRolesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Role By Id
 */

export function useGetRoleManagementRolesIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementRolesId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementRolesIdInfiniteQueryOptions(
    id,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementRolesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementRolesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementRolesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRolesId>>
  > = ({ signal }) => getRoleManagementRolesId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRolesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementRolesId>>
>;
export type GetRoleManagementRolesIdQueryError = void;

export function useGetRoleManagementRolesId<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesId>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesId<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesId>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesId<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Role By Id
 */

export function useGetRoleManagementRolesId<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementRolesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete Role
 */
export const deleteRoleManagementRolesId = (id: number) => {
  return customInstance<boolean>({
    url: `/role-management/roles/${id}`,
    method: "DELETE",
  });
};

export const getDeleteRoleManagementRolesIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoleManagementRolesId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRoleManagementRolesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteRoleManagementRolesId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRoleManagementRolesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteRoleManagementRolesId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleManagementRolesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRoleManagementRolesId>>
>;

export type DeleteRoleManagementRolesIdMutationError = void;

/**
 * @summary Delete Role
 */
export const useDeleteRoleManagementRolesId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRoleManagementRolesId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRoleManagementRolesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDeleteRoleManagementRolesIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Permissions
 */
export const putRoleManagementRolesIdPermissions = (
  id: number,
  rolePermissionDto: RolePermissionDto[],
) => {
  return customInstance<RolePermissionDto[]>({
    url: `/role-management/roles/${id}/permissions`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: rolePermissionDto,
  });
};

export const getPutRoleManagementRolesIdPermissionsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>,
    TError,
    { id: number; data: RolePermissionDto[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>,
  TError,
  { id: number; data: RolePermissionDto[] },
  TContext
> => {
  const mutationKey = ["putRoleManagementRolesIdPermissions"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>,
    { id: number; data: RolePermissionDto[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return putRoleManagementRolesIdPermissions(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutRoleManagementRolesIdPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>
>;
export type PutRoleManagementRolesIdPermissionsMutationBody =
  RolePermissionDto[];
export type PutRoleManagementRolesIdPermissionsMutationError = void;

/**
 * @summary Update Permissions
 */
export const usePutRoleManagementRolesIdPermissions = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>,
      TError,
      { id: number; data: RolePermissionDto[] },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putRoleManagementRolesIdPermissions>>,
  TError,
  { id: number; data: RolePermissionDto[] },
  TContext
> => {
  const mutationOptions =
    getPutRoleManagementRolesIdPermissionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Permissions
 */
export const getRoleManagementRolesIdPermissions = (
  id: number,
  signal?: AbortSignal,
) => {
  return customInstance<RolePermissionDto[]>({
    url: `/role-management/roles/${id}/permissions`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementRolesIdPermissionsInfiniteQueryKey = (
  id?: number,
) => {
  return ["infinite", `/role-management/roles/${id}/permissions`] as const;
};

export const getGetRoleManagementRolesIdPermissionsQueryKey = (id?: number) => {
  return [`/role-management/roles/${id}/permissions`] as const;
};

export const getGetRoleManagementRolesIdPermissionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleManagementRolesIdPermissionsInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  > = ({ signal }) => getRoleManagementRolesIdPermissions(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesIdPermissionsInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>>;
export type GetRoleManagementRolesIdPermissionsInfiniteQueryError = void;

export function useGetRoleManagementRolesIdPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  >,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Permissions
 */

export function useGetRoleManagementRolesIdPermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  >,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRoleManagementRolesIdPermissionsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementRolesIdPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleManagementRolesIdPermissionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
  > = ({ signal }) => getRoleManagementRolesIdPermissions(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementRolesIdPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
>;
export type GetRoleManagementRolesIdPermissionsQueryError = void;

export function useGetRoleManagementRolesIdPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementRolesIdPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Permissions
 */

export function useGetRoleManagementRolesIdPermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementRolesIdPermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementRolesIdPermissionsQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Tenant Users
 */
export const getRoleManagementUsers = (signal?: AbortSignal) => {
  return customInstance<TenantUserDto[]>({
    url: `/role-management/users`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementUsersInfiniteQueryKey = () => {
  return ["infinite", `/role-management/users`] as const;
};

export const getGetRoleManagementUsersQueryKey = () => {
  return [`/role-management/users`] as const;
};

export const getGetRoleManagementUsersInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementUsers>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementUsersInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsers>>
  > = ({ signal }) => getRoleManagementUsers(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsers>>
>;
export type GetRoleManagementUsersInfiniteQueryError = void;

export function useGetRoleManagementUsersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementUsers>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsers>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementUsers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsers>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementUsers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Users
 */

export function useGetRoleManagementUsersInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getRoleManagementUsers>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementUsersInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementUsers>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsers>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementUsersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsers>>
  > = ({ signal }) => getRoleManagementUsers(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsers>>
>;
export type GetRoleManagementUsersQueryError = void;

export function useGetRoleManagementUsers<
  TData = Awaited<ReturnType<typeof getRoleManagementUsers>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsers>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsers<
  TData = Awaited<ReturnType<typeof getRoleManagementUsers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsers>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsers<
  TData = Awaited<ReturnType<typeof getRoleManagementUsers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Tenant Users
 */

export function useGetRoleManagementUsers<
  TData = Awaited<ReturnType<typeof getRoleManagementUsers>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create User
 */
export const postRoleManagementUsers = (
  userDto: UserDto,
  signal?: AbortSignal,
) => {
  return customInstance<RegisterResponseDTO>({
    url: `/role-management/users`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: userDto,
    signal,
  });
};

export const getPostRoleManagementUsersMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRoleManagementUsers>>,
    TError,
    { data: UserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRoleManagementUsers>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationKey = ["postRoleManagementUsers"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRoleManagementUsers>>,
    { data: UserDto }
  > = (props) => {
    const { data } = props ?? {};

    return postRoleManagementUsers(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRoleManagementUsersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRoleManagementUsers>>
>;
export type PostRoleManagementUsersMutationBody = UserDto;
export type PostRoleManagementUsersMutationError = void;

/**
 * @summary Create User
 */
export const usePostRoleManagementUsers = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRoleManagementUsers>>,
      TError,
      { data: UserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRoleManagementUsers>>,
  TError,
  { data: UserDto },
  TContext
> => {
  const mutationOptions = getPostRoleManagementUsersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get My Permissions
 */
export const getRoleManagementUsersMePermissions = (signal?: AbortSignal) => {
  return customInstance<RolePermissionDto[]>({
    url: `/role-management/users/me/permissions`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementUsersMePermissionsInfiniteQueryKey = () => {
  return ["infinite", `/role-management/users/me/permissions`] as const;
};

export const getGetRoleManagementUsersMePermissionsQueryKey = () => {
  return [`/role-management/users/me/permissions`] as const;
};

export const getGetRoleManagementUsersMePermissionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleManagementUsersMePermissionsInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  > = ({ signal }) => getRoleManagementUsersMePermissions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersMePermissionsInfiniteQueryResult =
  NonNullable<Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>>;
export type GetRoleManagementUsersMePermissionsInfiniteQueryError = void;

export function useGetRoleManagementUsersMePermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMePermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMePermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Permissions
 */

export function useGetRoleManagementUsersMePermissionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRoleManagementUsersMePermissionsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementUsersMePermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementUsersMePermissionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
  > = ({ signal }) => getRoleManagementUsersMePermissions(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersMePermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
>;
export type GetRoleManagementUsersMePermissionsQueryError = void;

export function useGetRoleManagementUsersMePermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMePermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMePermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Permissions
 */

export function useGetRoleManagementUsersMePermissions<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMePermissions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRoleManagementUsersMePermissionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get My Role
 */
export const getRoleManagementUsersMeRole = (signal?: AbortSignal) => {
  return customInstance<UserRoleAssignmentDto>({
    url: `/role-management/users/me/role`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementUsersMeRoleInfiniteQueryKey = () => {
  return ["infinite", `/role-management/users/me/role`] as const;
};

export const getGetRoleManagementUsersMeRoleQueryKey = () => {
  return [`/role-management/users/me/role`] as const;
};

export const getGetRoleManagementUsersMeRoleInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  >,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementUsersMeRoleInfiniteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  > = ({ signal }) => getRoleManagementUsersMeRole(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersMeRoleInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
>;
export type GetRoleManagementUsersMeRoleInfiniteQueryError = void;

export function useGetRoleManagementUsersMeRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  >,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMeRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMeRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Role
 */

export function useGetRoleManagementUsersMeRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  >,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetRoleManagementUsersMeRoleInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementUsersMeRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetRoleManagementUsersMeRoleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
  > = ({ signal }) => getRoleManagementUsersMeRole(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersMeRoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
>;
export type GetRoleManagementUsersMeRoleQueryError = void;

export function useGetRoleManagementUsersMeRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMeRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersMeRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Role
 */

export function useGetRoleManagementUsersMeRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersMeRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementUsersMeRoleQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete User
 */
export const deleteRoleManagementUsersUserId = (userId: number) => {
  return customInstance<boolean>({
    url: `/role-management/users/${userId}`,
    method: "DELETE",
  });
};

export const getDeleteRoleManagementUsersUserIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>,
    TError,
    { userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ["deleteRoleManagementUsersUserId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>,
    { userId: number }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteRoleManagementUsersUserId(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleManagementUsersUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>
>;

export type DeleteRoleManagementUsersUserIdMutationError = void;

/**
 * @summary Delete User
 */
export const useDeleteRoleManagementUsersUserId = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>,
      TError,
      { userId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserId>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteRoleManagementUsersUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Unassign Role
 */
export const deleteRoleManagementUsersUserIdRole = (userId: number) => {
  return customInstance<boolean>({
    url: `/role-management/users/${userId}/role`,
    method: "DELETE",
  });
};

export const getDeleteRoleManagementUsersUserIdRoleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>,
    TError,
    { userId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationKey = ["deleteRoleManagementUsersUserIdRole"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>,
    { userId: number }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteRoleManagementUsersUserIdRole(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRoleManagementUsersUserIdRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>
>;

export type DeleteRoleManagementUsersUserIdRoleMutationError = void;

/**
 * @summary Unassign Role
 */
export const useDeleteRoleManagementUsersUserIdRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>,
      TError,
      { userId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRoleManagementUsersUserIdRole>>,
  TError,
  { userId: number },
  TContext
> => {
  const mutationOptions =
    getDeleteRoleManagementUsersUserIdRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get User Role
 */
export const getRoleManagementUsersUserIdRole = (
  userId: number,
  signal?: AbortSignal,
) => {
  return customInstance<UserRoleAssignmentDto>({
    url: `/role-management/users/${userId}/role`,
    method: "GET",
    signal,
  });
};

export const getGetRoleManagementUsersUserIdRoleInfiniteQueryKey = (
  userId?: number,
) => {
  return ["infinite", `/role-management/users/${userId}/role`] as const;
};

export const getGetRoleManagementUsersUserIdRoleQueryKey = (
  userId?: number,
) => {
  return [`/role-management/users/${userId}/role`] as const;
};

export const getGetRoleManagementUsersUserIdRoleInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  >,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleManagementUsersUserIdRoleInfiniteQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  > = ({ signal }) => getRoleManagementUsersUserIdRole(userId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersUserIdRoleInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
>;
export type GetRoleManagementUsersUserIdRoleInfiniteQueryError = void;

export function useGetRoleManagementUsersUserIdRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  >,
  TError = void,
>(
  userId: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersUserIdRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  >,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersUserIdRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  >,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Role
 */

export function useGetRoleManagementUsersUserIdRoleInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  >,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementUsersUserIdRoleInfiniteQueryOptions(
    userId,
    options,
  );

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetRoleManagementUsersUserIdRoleQueryOptions = <
  TData = Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRoleManagementUsersUserIdRoleQueryKey(userId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
  > = ({ signal }) => getRoleManagementUsersUserIdRole(userId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRoleManagementUsersUserIdRoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
>;
export type GetRoleManagementUsersUserIdRoleQueryError = void;

export function useGetRoleManagementUsersUserIdRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
  TError = void,
>(
  userId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersUserIdRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
          TError,
          Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRoleManagementUsersUserIdRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Role
 */

export function useGetRoleManagementUsersUserIdRole<
  TData = Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
  TError = void,
>(
  userId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRoleManagementUsersUserIdRole>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRoleManagementUsersUserIdRoleQueryOptions(
    userId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assign Role
 */
export const postRoleManagementUsersUserIdRole = (
  userId: number,
  params?: PostRoleManagementUsersUserIdRoleParams,
  signal?: AbortSignal,
) => {
  return customInstance<UserRoleAssignmentDto>({
    url: `/role-management/users/${userId}/role`,
    method: "POST",
    params,
    signal,
  });
};

export const getPostRoleManagementUsersUserIdRoleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>,
    TError,
    { userId: number; params?: PostRoleManagementUsersUserIdRoleParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>,
  TError,
  { userId: number; params?: PostRoleManagementUsersUserIdRoleParams },
  TContext
> => {
  const mutationKey = ["postRoleManagementUsersUserIdRole"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>,
    { userId: number; params?: PostRoleManagementUsersUserIdRoleParams }
  > = (props) => {
    const { userId, params } = props ?? {};

    return postRoleManagementUsersUserIdRole(userId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostRoleManagementUsersUserIdRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>
>;

export type PostRoleManagementUsersUserIdRoleMutationError = void;

/**
 * @summary Assign Role
 */
export const usePostRoleManagementUsersUserIdRole = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>,
      TError,
      { userId: number; params?: PostRoleManagementUsersUserIdRoleParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRoleManagementUsersUserIdRole>>,
  TError,
  { userId: number; params?: PostRoleManagementUsersUserIdRoleParams },
  TContext
> => {
  const mutationOptions =
    getPostRoleManagementUsersUserIdRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
